/**
 * Which containers have drop times outside the country's window (user,
 * 18/10/2026: "after updating the window, these containers must be shown
 * separately or with an icon"). Read from the timing mirror — the planner's
 * own rules — so the board, and the Times dialog with a window not saved
 * yet, say what the planner will do.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { ContainerTimes } from '../slot-times';

export interface OutsideCount {
  /** Drop times outside the window that will NOT go (the window is a hard limit). */
  cut: number;
  /** Drop times outside the window that go anyway (Schedule › Outside the window, or the drop's 🌙) — never a route
   *  test's drops: they go before the window on every route test, by design (20/10/2026), so no row is marked for them. */
  sent: number;
  /** Every enabled drop time of the container. */
  total: number;
}

export function outsideOf(times: ContainerTimes | undefined): OutsideCount {
  const live = (times?.slotTimes ?? []).filter((t) => !t.clamped);
  return {
    cut: live.filter((t) => t.outsideWindow).length,
    sent: live.filter((t) => t.sentOutside && !t.routeTest).length,
    total: live.length,
  };
}

export interface OutsideContainer extends OutsideCount {
  id: string;
  name: string;
}

/** The enabled containers with at least one drop time cut by the window, board order. */
export function containersCut(
  containers: Array<{ id: string; name: string; enabled: boolean }>,
  times: Map<string, ContainerTimes>,
): OutsideContainer[] {
  return containers
    .filter((c) => c.enabled)
    .map((c) => ({ id: c.id, name: c.name, ...outsideOf(times.get(c.id)) }))
    .filter((c) => c.cut > 0);
}
